import styled from 'styled-components';

const Headline = styled.div`
    font-size: 23px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.52;
    letter-spacing: normal;
    text-align: left;
    padding-top: 40px;
    color: black;
`;

export default Headline;
